import React from "react";
import OptionEdit from "./OptionEdit";
import OptionView from "./OptionView";

const Option = ({
  option,
  index,
  options,
  editModes,
  setEditModes,
  handleOptionNameChange,
  handleOptionValueChange,
  handleDeleteValue,
  handleDeleteOption,
  handleToggleValueDisabled,
  handleDone,
  handleEdit,
  canAddVariants,
  setOptions,
  opts,
  setVariants
}) => {
  const renderOptionContent = () => {
    if (editModes[option.id]) {
      return (
        <OptionEdit
          option={option}
          index={index}
          options={options}
          setOptions={setOptions}
          handleOptionNameChange={handleOptionNameChange}
          handleOptionValueChange={handleOptionValueChange}
          handleDeleteValue={handleDeleteValue}
          handleToggleValueDisabled={handleToggleValueDisabled}
          handleDeleteOption={handleDeleteOption}
          handleDone={handleDone}
          setEditModes={setEditModes}
          canAddVariants={canAddVariants}
          opts={opts}
          setVariants={setVariants}
        />
      );
    }

    return (
      <OptionView 
        option={option} 
        handleEdit={handleEdit} 
        options={options} 
        setOptions={setOptions} 
        setEditModes={setEditModes} 
        opts={opts} 
      />
    );
  };

  return (
    <>
      {renderOptionContent()}
    </>
  );
};

export default Option;